import { useState, type MouseEvent } from 'react';
import { Menu, MenuItem, Divider } from '@mui/material';
import { Edit as EditIcon, Delete as DeleteIcon, MoreVert as MoreIcon } from '@mui/icons-material';
import { GridActionsCellItem } from '@mui/x-data-grid';
import { useTranslation } from 'react-i18next';
import type { Skill } from '@/types/domain';

export interface SkillMoreActionsProps {
  skill: Skill;
  onEdit: () => void;
  onDelete: () => void;
}

/**
 * 技能更多操作菜单组件
 * 提供编辑和删除操作的展开菜单
 */
export default function SkillMoreActions({ skill, onEdit, onDelete }: SkillMoreActionsProps) {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleEdit = () => {
    handleClose();
    onEdit();
  };

  const handleDelete = () => {
    handleClose();
    onDelete();
  };

  return (
    <>
      <GridActionsCellItem
        icon={<MoreIcon />}
        label={t('skills.moreActions')}
        onClick={handleClick}
      />
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <MenuItem onClick={handleEdit}>
          <EditIcon fontSize="small" sx={{ mr: 1 }} />
          {t('common.edit')}
        </MenuItem>
        <Divider />
        <MenuItem
          onClick={handleDelete}
          disabled={!!skill.builtin}
          sx={{ color: 'error.main' }}
        >
          <DeleteIcon fontSize="small" sx={{ mr: 1 }} />
          {t('common.delete')}
        </MenuItem>
      </Menu>
    </>
  );
}
